module.exports = __webpack_public_path__ + "static/img/logo.fffa086.png";


//////////////////
// WEBPACK FOOTER
// ./static/wap_images/logo.png
// module id = 9P6v
// module chunks = 1